// ProductImageCell.jsx
import React, { useState } from "react";
import {
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ZoomIn from "@mui/icons-material/ZoomIn";
import FilterIcon from '@mui/icons-material/Filter';

export default function ProductImageCell({
  src,
  onDelete,
  onToggleBackground,
  hasBackground = true,
  showDelete = true
}) {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    onToggleBackground?.();
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 60 }}>
      <Box
        component="img"
        src={src}
        alt="thumb"
        onClick={() => setOpen(true)}
        sx={{
          width: 300,
          height: 300,
          objectFit: "cover",
          borderRadius: 1,
          cursor: "pointer",
          border: "1px solid #ccc",
        }}
      />
      <Box sx={{ display: "flex", gap: 0.5, mt: 0.5 }}>
        <Tooltip title="View larger">
          <IconButton size="large" onClick={() => setOpen(true)}>
            <ZoomIn fontSize="large" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Toggle background">
          <IconButton size="large" onClick={handleToggle}>
            <FilterIcon
              fontSize="large"
              color={hasBackground ? "primary" : "disabled"}
            />
          </IconButton>
        </Tooltip>
        {showDelete && (<Tooltip title="Delete image">
          <IconButton size="large" onClick={onDelete}>
            <DeleteIcon fontSize="large" />
          </IconButton>
        </Tooltip>)}

      </Box>

      {/* Full Image Preview Dialog */}
      <Dialog open={open} keepMounted onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogContent>
          <Box
            component="img"
            src={src}
            alt="full"
            sx={{ width: "100%", objectFit: "contain" }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <Box>
            <Button
              startIcon={<FilterIcon />}
              onClick={handleToggle}
              variant="outlined"
              color={hasBackground ? "primary" : "inherit"}
            >
              {hasBackground ? "Hide Background" : "Show Background"}
            </Button>
          </Box>
          <Button onClick={() => setOpen(false)} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}